import { CustomerAPI } from 'api'

export const getSidebarProperties = (orgID) => (
  CustomerAPI.get(`/organizations/${orgID}/properties`)
)

export const saveSidebarProperties = (orgID, payload) => (
  CustomerAPI.patch(`/organizations/${orgID}/properties2`, payload)
)

export const saveNewSidebarConfig = (payload) => (
  CustomerAPI.post(`/organizations/sidebar/settings`, payload)
)

export const saveNewSidebarConfigExisting = (payload) => (
  CustomerAPI.patch(`/organizations/sidebar/settings`, payload)
)

export const getNewSidebarConfig = () => (
  CustomerAPI.get(`/organizations/sidebar/settings`)
)

export const checkHasNewSidebarConfig = () => (
  CustomerAPI.head(`/organizations/sidebar/settings`)
)

export const deleteCard = (id) => (
  CustomerAPI.delete(`/organizations/sidebar/settings/${id}`, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
)